module.exports = __webpack_public_path__ + "static/media/Papers.d2ad6581.png";